<template>
  <div class="content">
    <div class="speed">
      ©
      <a v-if="orgType === 'association'" href="https://associacoes.org" target="_blank">
        associacoes.org
      </a>
      <a v-else-if="orgType === 'cooperative'" href="https://coops.org" target="_blank">
        coops.pt
      </a>
      {{ new Date().getFullYear() }} |
      <span :title="buildDate">v{{ appVersion }} · {{ buildDateShort }}</span>
      | tempo da última resposta: {{ responseTime }} ms
      <template v-if="hasPrivacyPolicy">
        |
        <router-link :to="{ name: 'privacyPolicy' }">
          Política de privacidade de {{ orgName }}
        </router-link>
      </template>
      <template v-if="showDataProcessingAgreement">
        |
        <router-link :to="{ name: 'dataProcessingAgreement' }">
          Contrato de subcontratação (rascunho)
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isDataProcessingAgreementEnabled } from '@/lib/dataProcessingAgreement'

export default {
  name: 'FooterEl',
  data() {
    return {
      appVersion: __APP_VERSION__,
      buildDate: __APP_BUILD_DATE__,
      orgName: import.meta.env.VITE_TITLE,
    }
  },
  computed: {
    buildDateShort() {
      return this.buildDate.slice(0, 10)
    },
    responseTime() {
      return this.$store.state.responseTime
    },
    ...mapGetters({
      orgType: 'settings/orgType',
      settingsByName: 'settings/listByName',
      isLoggedin: 'auth/isLoggedin',
      isAdminOrEditor: 'auth/isAdminOrEditor',
    }),
    // #237 — no policy written, no link. Orgs that publish nothing keep the
    // footer exactly as it was.
    hasPrivacyPolicy() {
      return (this.settingsByName?.privacyPolicy?.value || '') !== ''
    },
    // #237 — the processing contract is org↔coops.pt business, so it is shown to
    // admins/editors only. isAdminOrEditor reads effectiveRole, so it also hides
    // while an admin is toggled into member view. It is additionally gated to the
    // orgs it has been rolled out to (Pro Nobis only, while it is a draft).
    showDataProcessingAgreement() {
      return this.isLoggedin && this.isAdminOrEditor && isDataProcessingAgreementEnabled()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  padding: 2rem;
  color: white;
  .speed {
    font-size: 0.6rem;
  }
}

a {
  color: white;
}
</style>
